import create from 'zustand';

export interface SoundsPreloadStoreType {
  library: { [key: string]: { src: string } };
  initialPreloaded: boolean;
  setInitialPreloaded: (preloaded: boolean) => void;
  preloaded: boolean;
  setPreloaded: (preloaded: boolean) => void;
  dynamicPreloaded: boolean;
  setDynamicPreloaded: (preloaded: boolean) => void;
}

export const useSoundsPreloadStore = create<SoundsPreloadStoreType>(set => ({
  library: {},
  initialPreloaded: false,
  setInitialPreloaded: preloaded => set({ initialPreloaded: preloaded }),
  preloaded: false,
  setPreloaded: preloaded => set({ preloaded }),
  dynamicPreloaded: false,
  setDynamicPreloaded: preloaded => set({ dynamicPreloaded: preloaded }),
}));

export default useSoundsPreloadStore;
